import { UserActions } from '../actions';

export const drivers = (state = null, actions) => {
  switch (actions.type) {
    case UserActions.FETCH_DRIVERS:
      return Object.assign({}, state, { fetching: true });
    case UserActions.DRIVERS_RECEIVED:
      return Object.assign({}, state, { fetching: false, list: actions.drivers });
    default:
      return state;
  }
}

export default drivers;


// WEBPACK FOOTER //
// ./src/reducers/drivers.js